export const loadFbSdk = () => {
  const script = document.createElement("script");
  script.src = "https://connect.facebook.net/en_US/sdk.js";
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
};

export const loadingMessageToText = (message: string) => {
  if (!message) {
    return null;
  }

  const prefix = `[META]`;
  if (message.includes("CREATING_CUSTOM_AUDIENCE")) {
    return `${prefix} Creating custom audience`;
  }

  if (message.includes("PUBLISHING_ADSET")) {
    return `${prefix} Publishing adset`;
  }

  if (message.includes("CREATING_CAMPAIGN")) {
    return `${prefix} Creating campaign`;
  }

  if (message.includes("PUBLISHING_CAMPAIGN")) {
    return `${prefix} Publishing campaign`;
  }

  if (message.includes("UPDATING_CAMPAIGN")) {
    return `${prefix} Updating campaign`;
  }

  if (message.includes("UPDATING_ADSET")) {
    return `${prefix} Updating adset`;
  }

  if (message.includes("CREATING_ADSET")) {
    return `${prefix} Creating adset`;
  }

  if (message.includes("CREATING_AD_CREATIVE")) {
    return `${prefix} Creating ad creative`;
  }

  if (message.includes("UPDATING_AD")) {
    return `${prefix} Updating ad`;
  }

  if (message.includes("CREATING_AD")) {
    return `${prefix} Creating ad`;
  }

  return message;
};

export function validateAspectRatio(
  file: File,
  ratioRanges: { min: string; max: string },
  tolerance = 0.01,
  separator = "/"
): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const [minWidth, minHeight] = ratioRanges.min.split(separator);
    const [maxWidth, maxHeight] = ratioRanges.max.split(separator);
    
    const minRatio = Number(minWidth) / Number(minHeight);
    const maxRatio = Number(maxWidth) / Number(maxHeight);

    if (file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          const aspectRatio = img.width / img.height;
          resolve(aspectRatio >= minRatio - tolerance && aspectRatio <= maxRatio + tolerance);
        };
        img.onerror = () => reject(new Error("Failed to load image."));
        img.src = event.target.result as string;
      };
      reader.onerror = () => reject(new Error("Failed to read file."));
      reader.readAsDataURL(file);
    } 
    else if (file.type.startsWith("video/")) {
      const video = document.createElement("video");
      video.preload = "metadata";

      video.onloadedmetadata = () => {
        const aspectRatio = video.videoWidth / video.videoHeight;
        resolve(aspectRatio >= minRatio - tolerance && aspectRatio <= maxRatio + tolerance);
      };

      video.onerror = () => reject(new Error("Failed to load video."));
      video.src = URL.createObjectURL(file);
    } 
    else {
      reject(new Error("File must be an image or video."));
    }
  });
}

export type AspectRatioRequirement = {
  min: string;
  max: string;
  description?: string; // Optional description for the requirement
};

export async function validateMultipleAspectRatios(
  file: File,
  ratioRequirements: AspectRatioRequirement[],
  tolerance = 0.01
): Promise<boolean> {
  for (const requirement of ratioRequirements) {
    try {
      const isValid = await validateAspectRatio(file, requirement, tolerance);
      if (isValid) {
        return true;
      }
    } catch (error) {
      console.error('Error validating aspect ratio:', error);
    }
  }
  
  return false;
}
